import type { Order } from "@graphql/generated/types";
import type { IPaymentStrategy } from "@interfaces/payment-method/PaymentStrategy";
import type { PaymentValues } from "../checkoutHelper";

export class PaymentProvider {
    private strategies: Map<string, IPaymentStrategy>;

    constructor(strategies: Map<string, IPaymentStrategy>) {
        this.strategies = strategies;
    }

    getPaymentMethod(order: Order, provider: string): PaymentValues {
        const strategy = this.strategies.get(provider);
        if (!strategy) throw new Error(`No strategy found for provider: ${provider}`);

        return strategy.resolve(order);
    }
}
